module.exports = __webpack_public_path__ + "static/media/CHei2-Xbold-HKSCS.aa226d97.svg";